import React from "react";
import Icon from "@mdi/react";
import {
  mdiWeb,
  mdiTwitter,
  mdiDribbble,
  mdiInstagram,
  mdiLinkedin
} from "@mdi/js";

const icons = {
  web: mdiWeb,
  twitter: mdiTwitter,
  dribbble: mdiDribbble,
  instagram: mdiInstagram,
  linkedin: mdiLinkedin
};

// Add protocol part
const harmonize = link =>
  /^https?:\/\//.test(link) ? link : `https://${link}`;

// Remove protocol part of url
const clean = link => link.replace(/https?:\/\//i, "");

export default ({ href, children, icon, ...props }) => (
  <span className="link">
    {icon && (
      <Icon
        path={icons[icon]}
        size="20px"
        color="#000000"
        className="link_icon"
      />
    )}
    <a
      className="link_a"
      href={harmonize(href || children)}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {clean(children)}
    </a>
  </span>
);
